module.exports = __webpack_public_path__ + "img/banner3.2d655880.jpg";